import { Outlet, useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";

import { ROUTE_CONFIG } from "@/routes/config";

import { Logo } from "../Logo/Logo";

import { Button } from "../Button/Button";
import { Footer } from "../Footer/Footer";

const { HOME, LOGIN } = ROUTE_CONFIG;

export const AuthLayout = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	return (
		<div className="w-full h-[100vh] relative font-urbanist flex flex-col" id="portal-auth">
			<div className="h-[92px] w-full border-b border-primary-gray-lightest flex items-center justify-between p-6">
				<div className="flex gap-3 items-center justify-center w-fit">
					<Logo handleClick={() => navigate(HOME)} />
				</div>

				<div className="flex flex-row items-center w-fit gap-2">
					<Button title={t("login.loginCta")} onClick={() => navigate(LOGIN)} />
				</div>
			</div>
			<div className="flex-1 relative w-full">
				<Outlet />
			</div>
			<Footer />
		</div>
	);
};
